export default __webpack_public_path__ + "static/media/map-marker.96eda576.svg";